import { render, staticRenderFns } from "./SubscriptionButton.vue?vue&type=template&id=6f8d5e20"
import script from "./SubscriptionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports